export const SUPPORT_EMAIL = 'support@peachfy.com'
export const INFO_EMAIL = 'info@peachfy.com'
